export default class Popup {
    constructor() {
        this.popupModalWrapper = document.querySelector(".itemPopupWrapperJs");
        this.popupModalLayer = document.querySelector(
            ".itemPopupWrapperJs .itemPopup__layer"
        );
        this.popupModal = document.querySelector(
            ".itemPopupWrapperJs .itemPopup"
        );
        this.popupModalClose = document.querySelector(
            ".itemPopupWrapperJs .itemPopupHeader__close"
        );

        if (this.popupModal) {
            if (this.popupModal.dataset.onmouseout == 0) {
                const cookie = this.getCookie(
                    "popup-" + this.popupModal.dataset.id
                );

                if (!cookie) {
                    this.openModal();
                }
            } else {
                document.body.addEventListener(
                    "mouseleave",
                    this.openModal.bind(this)
                );
            }
            this.events();
        }
    }

    events() {
        this.popupModalLayer.addEventListener(
            "click",
            this.closeModal.bind(this)
        );
        this.popupModalClose.addEventListener(
            "click",
            this.closeModal.bind(this)
        );
    }

    closeModal() {
        const self = this;
        const id = this.popupModal.dataset.id;
        const executionTime = this.popupModal.dataset.executionTime;
        this.popupModalWrapper.classList.remove("active");

        const cookie = self.getCookie("popup-" + id);
        if (!cookie) {
            self.setCookie("popup-" + id, 1, executionTime);
        }
    }

    openModal() {
        const wrapper = this.popupModalWrapper;
        setTimeout(function () {
            wrapper.classList.add("active");
        }, this.popupModal.dataset.time);
    }

    setCookie(cname, cvalue, exdays) {
        if (exdays.length == 0 || parseInt(exdays) <= 0) {
            return;
        }

        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";expires=" + expires;
    }

    getCookie(cname) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
